//import { get } from 'lodash';
// import { contentPages as cK } from 'src/tools/contentModulesFieldName';
import arrayMove from 'array-move';

const useContentTab = () => {
  const handleOnModalConfirm = (value, onChange, newContent, index) => {
    const nV = (value || []).map((d, i) => {
      if (i === index) {
        return newContent;
      } else {
        return d;
      }
    });
    onChange(nV);
  };
  const handleOnAdd = (value, onChange, data) => {
    //const pc = generateNewContentPage();
    //const { pc } = ;
    onChange([...(value || []), data]);
  };
  const handleOnDelete = (value, onChange, index) => {
    const nValue = (value || []).filter((_, i) => {
      return i !== index;
    });
    onChange(nValue);
  };
  const handleOnSort = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  return { handleOnModalConfirm, handleOnAdd, handleOnDelete, handleOnSort };
};
export { useContentTab };
